import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HubConnectionBuilder, HttpTransportType } from '@aspnet/signalr';
import { map, groupBy, mergeMap, toArray, debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { from } from 'rxjs/internal/observable/from';
import { Subject, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Injectable, Inject, EventEmitter, Component, Input, Output, ViewChild, NgModule, ViewEncapsulation, defineInjectable, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatMenuTrigger, MatBadgeModule, MatMenuModule, MatProgressSpinnerModule, MatDividerModule, MatIconModule, MatDialogModule, MatCardModule, MatButtonModule, MatAutocompleteModule, MatProgressBarModule, MatInputModule } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { RTE_APP_SERVICE_DATA, TabService, TabParameter, RTE_COLOR_SERVICE_DATA, RteDialog, RTEAlertService, RteDialogRef, RteRetroactiveLabelModule, RteToolbarLiteModule, RteMaterialModule, RteAppTitleModule } from 'rte-library';
import { FormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteNotificationCenterService = /** @class */ (function () {
    function RteNotificationCenterService(httpClient, environment, tabService, appService) {
        this.httpClient = httpClient;
        this.environment = environment;
        this.tabService = tabService;
        this.appService = appService;
        this.reciveNotification = new EventEmitter();
    }
    /**
     * @return {?}
     */
    RteNotificationCenterService.prototype.getNCApiUrl = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var headers = new HttpHeaders({
            'No-loading': 'True'
        });
        return this.httpClient.get(this.environment.apiNotificationUrl + 'notification/GetNCApiUrl', { responseType: 'text', headers: headers });
    };
    /**
     * @return {?}
     */
    RteNotificationCenterService.prototype.countUnreadNotifications = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var headers = new HttpHeaders({
            'No-loading': 'True'
        });
        return this.httpClient.get(this.environment.apiNotificationUrl + 'notification/count', { headers: headers });
    };
    /**
     * @return {?}
     */
    RteNotificationCenterService.prototype.getLoadingNotification = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var headers = new HttpHeaders({
            'No-loading': 'True'
        });
        return this.httpClient.get(this.environment.apiNotificationUrl + 'notification/loading', { headers: headers });
    };
    /**
     * @param {?} page
     * @param {?} amountByPage
     * @param {?} popover
     * @param {?} searchObject
     * @return {?}
     */
    RteNotificationCenterService.prototype.getNotifications = /**
     * @param {?} page
     * @param {?} amountByPage
     * @param {?} popover
     * @param {?} searchObject
     * @return {?}
     */
    function (page, amountByPage, popover, searchObject) {
        /** @type {?} */
        var headers = new HttpHeaders();
        if (popover) {
            headers = new HttpHeaders({ 'No-loading': 'True' });
        }
        /** @type {?} */
        var params = new HttpParams();
        params = params.append('EndUserId', '1');
        params = params.append('Page', page.toString());
        params = params.append('AmountByPage', amountByPage.toString());
        if (searchObject) {
            if (searchObject.InitialDate != null && searchObject.FinalDate != null) {
                params = params.append('InitialDate', searchObject.InitialDate.toISOString());
                params = params.append('FinalDate', searchObject.FinalDate.toISOString());
            }
            if (searchObject.Title != null && searchObject.Title != '')
                params = params.append('Title', searchObject.Title);
            if (searchObject.Message != null && searchObject.Message != '')
                params = params.append('Message', searchObject.Message);
            if (searchObject.SenderUserId != null && searchObject.SenderUserId != 0)
                params = params.append('SenderUserId', searchObject.SenderUserId.toString());
        }
        /** @type {?} */
        var result = this.httpClient.get(this.environment.apiNotificationUrl + 'notification', { params: params, headers: headers });
        return result.pipe(map(function (response) {
            response.Data.forEach(function (item) {
                item.CreationDate = new Date(item.CreationDate);
            });
            return response;
        }));
    };
    /**
     * @param {?} notificationId
     * @return {?}
     */
    RteNotificationCenterService.prototype.setAsRead = /**
     * @param {?} notificationId
     * @return {?}
     */
    function (notificationId) {
        /** @type {?} */
        var headers = new HttpHeaders({
            'No-loading': 'True',
        });
        /** @type {?} */
        var params = new HttpParams();
        params = params.append('recipientId', notificationId.toString());
        return this.httpClient.put(this.environment.apiNotificationUrl + 'notification', null, { params: params, headers: headers });
    };
    /**
     * @param {?} notificationId
     * @return {?}
     */
    RteNotificationCenterService.prototype.getUserNameTrigger = /**
     * @param {?} notificationId
     * @return {?}
     */
    function (notificationId) {
        return this.httpClient.get(this.environment.apiNotificationUrl + 'notification/GetUserTrigger?recipientId=' + notificationId.toString(), { responseType: 'text' });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    RteNotificationCenterService.prototype.OpenApplicationNewTab = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var target = ((/** @type {?} */ (event.target)));
        if (target.hasAttribute('href')) {
            if (target.hasAttribute('target')) {
                window.open(target.getAttribute('href'), target.getAttribute('target'));
            }
            else {
                /** @type {?} */
                var dataAttributes = target.getAttributeNames().filter(function (attributes) { return attributes.includes('data-'); });
                /** @type {?} */
                var parameters_1 = [];
                dataAttributes.forEach(function (dataAttribute) {
                    /** @type {?} */
                    var parameter = new TabParameter();
                    parameter.PropertyName = dataAttribute.replace('data-', '');
                    parameter.Value = target.getAttribute(dataAttribute);
                    parameters_1.push(parameter);
                });
                /** @type {?} */
                var app = this.appService.applicationsToSearch.find(function (x) { return x.Id === target.getAttribute('href'); });
                if (app) {
                    this.tabService.openTab(app.Description, app.Id, false, app.Breadcrumb, parameters_1);
                }
                else {
                    this.tabService.openTab('Notificação', target.getAttribute('href'), false, 'Notificação', parameters_1);
                }
            }
        }
    };
    /**
     * @param {?} description
     * @return {?}
     */
    RteNotificationCenterService.prototype.getUserByDescription = /**
     * @param {?} description
     * @return {?}
     */
    function (description) {
        /** @type {?} */
        var headers = new HttpHeaders({
            'No-loading': 'True',
        });
        return this.httpClient.get(this.environment.apiUrl + 'api/user/getusersbydescription?description=' + description, { headers: headers });
    };
    RteNotificationCenterService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteNotificationCenterService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] },
        { type: TabService },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] }
    ]; };
    /** @nocollapse */ RteNotificationCenterService.ngInjectableDef = defineInjectable({ factory: function RteNotificationCenterService_Factory() { return new RteNotificationCenterService(inject(HttpClient), inject("environment"), inject(TabService), inject(RTE_APP_SERVICE_DATA)); }, token: RteNotificationCenterService, providedIn: "root" });
    return RteNotificationCenterService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var NotificationStatusMessageEnum = {
    Message: 0,
    Spinner: 1,
    Error: 2,
    Success: 3,
};
NotificationStatusMessageEnum[NotificationStatusMessageEnum.Message] = 'Message';
NotificationStatusMessageEnum[NotificationStatusMessageEnum.Spinner] = 'Spinner';
NotificationStatusMessageEnum[NotificationStatusMessageEnum.Error] = 'Error';
NotificationStatusMessageEnum[NotificationStatusMessageEnum.Success] = 'Success';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteNotificationDetailComponent = /** @class */ (function () {
    function RteNotificationDetailComponent(data, dialogRef, service, sanitizer) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.service = service;
        this.sanitizer = sanitizer;
        this.notificationSpinner = NotificationStatusMessageEnum.Spinner;
        this.notification = (/** @type {?} */ (this.data.item));
        this.menuTrigger = this.data.menuTrigger;
        this.notification.CreationDate = new Date(this.notification.CreationDate);
    }
    /**
     * @return {?}
     */
    RteNotificationDetailComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    RteNotificationDetailComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} event
     * @return {?}
     */
    RteNotificationDetailComponent.prototype.OpenApplication = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.preventDefault();
        this.dialogRef.close();
        if (this.menuTrigger) {
            this.menuTrigger.closeMenu();
        }
        this.service.OpenApplicationNewTab(event);
    };
    /**
     * @return {?}
     */
    RteNotificationDetailComponent.prototype.onClose = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    RteNotificationDetailComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-nc-rte-notification-detail',
                    template: "<div class=\"notification-detail-container\">\r\n  <h2 class=\"title\" rte-dialog-title>\r\n    <div class=\"mat-title\" [rteTooltip]=\"notification.Title\">{{notification.Title}}</div>\r\n  </h2>\r\n   \r\n  <div #divBody (click)=\"OpenApplication($event)\" class=\"body\" [innerHTML]=\"sanitizer.bypassSecurityTrustHtml(notification.Message)\">\r\n  </div>\r\n  <rte-progress-bar mode=\"indeterminate\" *ngIf=\"notification.StatusMessage === notificationSpinner\"></rte-progress-bar>\r\n  <div class=\"footer\">\r\n    <span *ngIf=\"notification.StatusMessage !== notificationSpinner\" class=\"sub-title\">{{notification.CreatorUserName}}, \r\n        em {{notification.CreationDate.toLocaleString().slice(0,16)}} - <rte-retroactive-label [date]=\"notification.CreationDate\"></rte-retroactive-label>\r\n    </span> \r\n  </div>\r\n\r\n  <mat-dialog-actions class=\"dialog-actions\">\r\n    <button rtebutton-stroked cdkFocusInitial (click)=\"onClose()\">Fechar</button>\r\n  </mat-dialog-actions>\r\n</div>",
                    styles: [".notification-detail-container{max-width:660px;width:660px;font-family:Roboto;display:flex;flex-direction:column}.notification-detail-container .footer{padding-top:15px;text-align:right;display:flex;flex-direction:column;margin-bottom:50px}.mt-progress{margin-top:10px}div .title .mat-title{padding-top:10px;width:100%;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.emoji{font-size:20px;display:contents;margin-bottom:10px}.notification-detail-container .title{font-style:normal;font-weight:500;font-size:18px;line-height:25px;color:#424242;display:block;padding-top:10px;width:auto}.align-center{align-self:center}.mat-dialog-title{margin-bottom:10px!important}h1{font-size:20px!important;margin-top:-17px!important;margin-bottom:30px!important;color:grey!important}.notification-detail-container .sub-title{color:#757575;font-size:12px;display:block;line-height:18px}.notification-detail-container .body{font-size:16px;color:#424242;display:block;max-height:calc(100vh - 377px);overflow-y:auto}.notification-detail-container .dialog-actions{text-align:end;width:auto}::ng-deep .mat-progress-bar-fill::after{background-color:#00bcd4}"]
                }] }
    ];
    /** @nocollapse */
    RteNotificationDetailComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: RteDialogRef },
        { type: RteNotificationCenterService },
        { type: DomSanitizer }
    ]; };
    RteNotificationDetailComponent.propDecorators = {
        divBody: [{ type: ViewChild, args: ['divBody',] }]
    };
    return RteNotificationDetailComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchNotification = /** @class */ (function () {
    function SearchNotification() {
    }
    return SearchNotification;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotificationUser = /** @class */ (function () {
    function NotificationUser() {
    }
    return NotificationUser;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotificationListComponent = /** @class */ (function () {
    function NotificationListComponent(apiService, dialog, alertService) {
        var _this = this;
        this.apiService = apiService;
        this.dialog = dialog;
        this.alertService = alertService;
        this.page = 1;
        this.pageSize = 20;
        this.expandPanelForm = false;
        this.searchObject = new SearchNotification();
        this.filteredUsers = [];
        this.isLoading = false;
        this.userName = '';
        this.userNameChanged = new Subject();
        this.selectedUser = new NotificationUser();
        this.subscription = new Subscription();
        this.notifications = [];
        this.agroupedNotification = new Array();
        this.userNameChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe(function (model) {
            if (model && model != '') {
                _this.getUsers();
            }
            else {
                _this.searchObject.SenderUserId = 0;
            }
        });
    }
    /**
     * @return {?}
     */
    NotificationListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.getNotifications();
        this.subscription.add(this.apiService.reciveNotification.subscribe(function (x) {
            _this.searchNotifications();
        }));
    };
    /**
     * @return {?}
     */
    NotificationListComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    NotificationListComponent.prototype.seeMoreClick = /**
     * @return {?}
     */
    function () {
        this.getNotifications();
    };
    /**
     * @param {?} item
     * @return {?}
     */
    NotificationListComponent.prototype.onClickNotificationItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (item.Status === 'NL') {
            this.apiService.setAsRead(item.Id).subscribe(function (r) {
                item.Status = 'LD';
            });
        }
        if (!item.CreatorUserName) {
            this.apiService.getUserNameTrigger(item.Id).subscribe(function (r) {
                item.CreatorUserName = r;
            });
        }
    };
    /**
     * @return {?}
     */
    NotificationListComponent.prototype.getNotifications = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if ((this.searchObject.InitialDate != null && this.searchObject.FinalDate == null) ||
            (this.searchObject.FinalDate != null && this.searchObject.InitialDate == null)) {
            this.alertService.warning('Período para pesquisa incorreto.');
            return;
        }
        this.apiService.getNotifications(this.page, this.pageSize, false, this.searchObject).subscribe(function (r) {
            for (var i = 0; i < r.Data.length; i++) {
                /** @type {?} */
                var element = r.Data[i];
                _this.notifications.push(element);
            }
            _this.groupNotifications();
            _this.page++;
            _this.showSeeMore = r.AmountPages >= _this.page;
        });
    };
    /**
     * @return {?}
     */
    NotificationListComponent.prototype.groupNotifications = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.agroupedNotification = [];
        /** @type {?} */
        var not = from(this.notifications);
        /** @type {?} */
        var notificationsAgrouped = not.pipe(groupBy(function (notify) { return notify.CreationDate.getDate(); }), mergeMap(function (group) { return group.pipe(toArray()); }));
        notificationsAgrouped.subscribe(function (r) {
            _this.agroupedNotification.push(r);
        });
    };
    /**
     * @return {?}
     */
    NotificationListComponent.prototype.getUsers = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.userName && this.userName != '') {
            this.isLoading = true;
            this.apiService.getUserByDescription(this.userName)
                .pipe(finalize(function () {
                _this.isLoading = false;
            }))
                .subscribe(function (data) {
                if (!data) {
                    _this.errorMsg = 'Erro na busca dos usuários.';
                    _this.filteredUsers = [];
                }
                else {
                    _this.errorMsg = '';
                    _this.filteredUsers = data;
                }
            });
        }
        else {
            this.searchObject.SenderUserId = 0;
        }
    };
    /**
     * @param {?} user
     * @return {?}
     */
    NotificationListComponent.prototype.setUserSelected = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        this.searchObject.SenderUserId = user.Id;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NotificationListComponent.prototype.onModelChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.userName && this.userName !== '') {
            this.userNameChanged.next(event);
        }
        else {
            this.filteredUsers = null;
            this.searchObject.SenderUserId = 0;
        }
    };
    /**
     * @return {?}
     */
    NotificationListComponent.prototype.searchNotifications = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.page = 1;
        this.pageSize = 20;
        this.notifications = [];
        if ((this.searchObject.InitialDate != null && this.searchObject.FinalDate == null) ||
            (this.searchObject.FinalDate != null && this.searchObject.InitialDate == null)) {
            this.alertService.warning('Período para pesquisa incorreto.');
            return;
        }
        this.apiService.getNotifications(this.page, this.pageSize, false, this.searchObject).subscribe(function (r) {
            for (var i = 0; i < r.Data.length; i++) {
                /** @type {?} */
                var element = r.Data[i];
                _this.notifications.push(element);
            }
            _this.groupNotifications();
            _this.page++;
            _this.showSeeMore = r.AmountPages >= _this.page;
            if (_this.notifications.length > 0) {
                _this.expandPanelForm = false;
            }
            else {
                _this.alertService.warning('Nenhuma notificação encontrada.');
            }
        });
    };
    NotificationListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-nc-notification-list',
                    template: "<rte-toolbar-lite [title]=\"'CENTRAL DE NOTIFICA\u00C7\u00D5ES'\" [showCloseButton]=\"false\" [showRteSeparator]=\"false\">\r\n</rte-toolbar-lite>\r\n<div class=\"wrapper\">\r\n  <rte-app-title></rte-app-title>\r\n  <rte-card>\r\n    <mat-card-header class=\"card-header\">\r\n      <mat-card-title>\r\n        Suas Notifica\u00E7\u00F5es\r\n      </mat-card-title>\r\n    </mat-card-header>\r\n    <mat-card-content>\r\n      <rte-accordion class=\"margin-accordion\">\r\n        <rte-expansion-panel [expanded]=\"expandPanelForm\"\r\n        (opened)=\"expandPanelForm = true\"\r\n        (closed)=\"expandPanelForm = false\">\r\n        <rte-expansion-panel-header class=\"panel-header\">\r\n          <rte-panel-title class=\"panel-title body-truncate\">\r\n            Filtros de pesquisa\r\n          </rte-panel-title>\r\n        </rte-expansion-panel-header>\r\n        <div class=\"content expansion margin-date\">\r\n          <div class='row-form'>\r\n            <div class='column-form'>\r\n              <rte-form-field class=\"date-field\">\r\n                <input #inputInitialDate\r\n                  rteInput\r\n                  [rteDatepicker]=\"initailDate\"\r\n                  [(ngModel)]=\"searchObject.InitialDate\"\r\n                  [max]=\"searchObject.FinalDate\"\r\n                  placeholder=\"Data inicial\"/>       \r\n                <rte-datepicker-toggle matSuffix [for]=\"initailDate\"></rte-datepicker-toggle>\r\n                <rte-datepicker #initailDate></rte-datepicker>     \r\n              </rte-form-field>\r\n            </div>\r\n            <div class='column-form'>\r\n              <rte-form-field>\r\n                <input #inputFinalDate \r\n                rteInput \r\n                [rteDatepicker]=\"finalDate\"\r\n                [(ngModel)]=\"searchObject.FinalDate\" \r\n                [min]=\"searchObject.InitialDate\"\r\n                placeholder=\"Data final\"/>\r\n                <rte-datepicker-toggle matSuffix [for]=\"finalDate\"></rte-datepicker-toggle>\r\n                <rte-datepicker #finalDate></rte-datepicker>      \r\n              </rte-form-field>\r\n            </div>\r\n          </div>\r\n          <div class='row-form'>\r\n            <div class='column-form'>\r\n              <rte-form-field> \r\n                <input rteInput disable-uppercase placeholder=\"T\u00EDtulo\"\r\n                [(ngModel)]=\"searchObject.Title\" />   \r\n              </rte-form-field>\r\n            </div>\r\n            <div class='column-form'>\r\n              <rte-form-field>\r\n                <input rteInput disable-uppercase placeholder=\"Mensagem\"\r\n                [(ngModel)]=\"searchObject.Message\" />  \r\n              </rte-form-field> \r\n            </div>\r\n          </div>\r\n      </div>\r\n      <div class=\"footer\">\r\n        <button rtebutton-flat color=\"primary\" (click)=\"searchNotifications()\" title=\"Pesquisar\">\r\n          <span class=\"rte-icon\">\r\n            Pesquisar\r\n          </span>\r\n        </button>\r\n      </div>\r\n        </rte-expansion-panel>\r\n\r\n        <div *ngFor=\"let notifications of agroupedNotification\">\r\n          <div *ngFor=\"let notification of notifications; first as isFirst\">\r\n            <p class=\"margin-date\" mat-subheader *ngIf=\"isFirst\">{{notification.CreationDate | date: 'dd/MM/yyyy'}}</p>\r\n            <rte-nc-notification-display \r\n              [notification]=\"notification\"\r\n              [popover]=\"false\" \r\n              (onclicknotificationPanel)=\"onClickNotificationItem($event)\">\r\n            </rte-nc-notification-display>\r\n          </div> \r\n        </div>\r\n      </rte-accordion>\r\n      <div class=\"divider\">\r\n        <rte-divider></rte-divider>\r\n      </div>\r\n      <div *ngIf=\"showSeeMore\" class=\"show-more mat-elevation-z2\">\r\n        <button \r\n          style=\"outline: none;\" \r\n          class=\"mat-button see-more\"  \r\n          (click)=\"seeMoreClick()\" \r\n          href=\"javascript:void(0);\">\r\n            Ver mais\r\n        </button>\r\n      </div>\r\n    </mat-card-content>\r\n  </rte-card>\r\n</div>",
                    styles: [".see-more{width:100%;height:100%;background-color:transparent;border:none;cursor:pointer;color:#00f}p{color:#9e9e9e}.margin-date{margin-top:40px!important}.show-more:hover{background-color:#eee}.show-more{margin:0 0 30px!important;-moz-text-align-last:center;text-align-last:center}.mat-divider{position:inherit!important;margin:15px 0}.mat-card-header{margin-bottom:20px!important;padding-bottom:20px!important}.mat-card-content{margin:0 30px!important}.footer{text-align:end;padding-right:15px}"]
                }] }
    ];
    /** @nocollapse */
    NotificationListComponent.ctorParameters = function () { return [
        { type: RteNotificationCenterService },
        { type: RteDialog },
        { type: RTEAlertService }
    ]; };
    return NotificationListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteNotificationComponent = /** @class */ (function () {
    function RteNotificationComponent(appService, apiService, dialog, router, tabService) {
        this.appService = appService;
        this.apiService = apiService;
        this.dialog = dialog;
        this.router = router;
        this.tabService = tabService;
        this.numberOfNotifications = 0;
        this.loading = true;
        this.verifyLoad = 0;
        this.hasLoading = true;
        this.noReload = false;
        this.notificationSize = 10;
    }
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.apiService.getNCApiUrl()
            .subscribe(function (r) {
            _this.nCApiUrl = r;
            _this.getLoading();
            _this.countNotification();
            _this.startConnection();
        });
        this.router.config.push({ path: 'notificationlist', component: NotificationListComponent });
    };
    /**
     * @private
     * @return {?}
     */
    RteNotificationComponent.prototype.startConnection = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.hubConnection = new HubConnectionBuilder()
            .withUrl(this.nCApiUrl + 'notification', {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets,
            accessTokenFactory: function () { return _this.appService.currentUser.accessToken; },
        })
            .build();
        this.startConnectionToNC();
        this.hubConnection.on('receivenotification', function (data) {
            _this.onReceiveNotification(data);
            _this.apiService.reciveNotification.emit(data);
        });
        this.hubConnection.on('reloadnotification', function () {
            if (_this.noReload) {
                _this.noReload = false;
            }
            else {
                _this.getLoading();
                _this.countNotification();
                _this.handleLoading();
            }
        });
        this.hubConnection.onclose(function (error) {
            if (error == null ||
                (error && error.message && error.message.includes('status code: 1006')))
                _this.startConnectionToNC();
        });
    };
    /**
     * @private
     * @return {?}
     */
    RteNotificationComponent.prototype.startConnectionToNC = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.hubConnection
            .start()
            .then(function () { return console.log('Connected to NC'); })
            .catch(function (err) {
            if (err == null) {
                setTimeout(function () {
                    _this.startConnection();
                }, 1000);
            }
            else
                console.log('Error while starting connection: ' + err);
        });
    };
    /**
     * @param {?} payload
     * @return {?}
     */
    RteNotificationComponent.prototype.onReceiveNotification = /**
     * @param {?} payload
     * @return {?}
     */
    function (payload) {
        /** @type {?} */
        var fullNotification = JSON.parse(payload);
        this.getLoading();
        this.countNotification();
        this.handleBrowserNotification((/** @type {?} */ (fullNotification)));
        this.handleLoading();
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.handleLoading = /**
     * @return {?}
     */
    function () {
        if (this.isOpenedMenu) {
            this.loadNotifications();
        }
        else {
            this.hasLoading = true;
        }
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.countNotification = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.apiService.countUnreadNotifications().subscribe(function (r) {
            _this.numberOfNotifications = r;
        });
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.getLoading = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.apiService.getLoadingNotification().subscribe(function (r) {
            _this.verifyLoad = r;
        });
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.onOpenMenuNotification = /**
     * @return {?}
     */
    function () {
        if (this.hasLoading) {
            this.loadNotifications();
        }
        this.hasLoading = false;
        this.isOpenedMenu = true;
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.onCloseMenuNotification = /**
     * @return {?}
     */
    function () {
        this.isOpenedMenu = false;
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.loadNotifications = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.loading = true;
        this.apiService.getNotifications(1, this.notificationSize, true, null).subscribe(function (r) {
            _this.notifications = r.Data;
            _this.loading = false;
        });
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.anyNotification = /**
     * @return {?}
     */
    function () {
        return this.notifications && this.notifications.length > 0;
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.anyUnreadNotification = /**
     * @return {?}
     */
    function () {
        return this.numberOfNotifications > 0;
    };
    /**
     * @param {?} payLoadNoti
     * @return {?}
     */
    RteNotificationComponent.prototype.handleBrowserNotification = /**
     * @param {?} payLoadNoti
     * @return {?}
     */
    function (payLoadNoti) {
        /** @type {?} */
        var notification = (/** @type {?} */ (Notification));
        if (!('Notification' in window)) {
            return;
        }
        if (notification.permission === 'granted') {
            this.sendBrowserNotification(payLoadNoti);
        }
        else if (notification.permission !== 'denied') {
            notification.requestPermission(function (permission) {
                if (permission === 'granted') {
                    this.sendBrowserNotification(payLoadNoti);
                }
            });
        }
    };
    /**
     * @param {?} payLoadNoti
     * @return {?}
     */
    RteNotificationComponent.prototype.sendBrowserNotification = /**
     * @param {?} payLoadNoti
     * @return {?}
     */
    function (payLoadNoti) {
        var _this = this;
        /** @type {?} */
        var opcoes = {
            body: payLoadNoti.Message,
            icon: payLoadNoti.Picture
        };
        /** @type {?} */
        var noti = new Notification(payLoadNoti.Title, opcoes);
        noti.onclick = function () { return _this.onClickNotificationItem(payLoadNoti); };
    };
    /**
     * @param {?} item
     * @return {?}
     */
    RteNotificationComponent.prototype.onClickNotificationItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        if (item.Status === 'NL') {
            this.noReload = true;
            this.apiService.setAsRead(item.Id).subscribe(function (r) {
                item.Status = 'LD';
                if (_this.numberOfNotifications > 0) {
                    _this.numberOfNotifications--;
                }
            });
        }
        if (!item.CreatorUserName) {
            this.apiService.getUserNameTrigger(item.Id).subscribe(function (r) {
                item.CreatorUserName = r;
                _this.openDialog(item);
            });
        }
        else {
            this.openDialog(item);
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    RteNotificationComponent.prototype.openDialog = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.dialog.customOpen(RteNotificationDetailComponent, {
            data: { item: item, menuTrigger: this.menuTrigger }
        });
    };
    /**
     * @return {?}
     */
    RteNotificationComponent.prototype.openAllNotification = /**
     * @return {?}
     */
    function () {
        this.menuTrigger.closeMenu();
        this.tabService.openTab('Todas as notificações', '/notificationlist', false, 'Central de Notificações / Todas as Notificações');
    };
    RteNotificationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-nc-notification',
                    template: "<div  class=\"notification-target badge-lens\"\r\n      [matBadge]=\"numberOfNotifications > 9 ? '9+' : numberOfNotifications\"\r\n      matBadgeColor=\"warn\"\r\n      #menuTrigger=\"matMenuTrigger\"\r\n      [matBadgeHidden]=\"verifyLoad !== 1 && !anyUnreadNotification()\"\r\n      [matMenuTriggerFor]=\"menu\"\r\n      (menuOpened)=\"onOpenMenuNotification()\"\r\n      (menuClosed)=\"onCloseMenuNotification()\">\r\n  \r\n    <ng-content *ngIf=\"verifyLoad === 1\" select='.notify-in-progress'>\r\n    </ng-content>    \r\n    <ng-content *ngIf=\"verifyLoad !== 1 && !anyUnreadNotification()\" select='.no-notify'>\r\n    </ng-content>\r\n    <ng-content *ngIf=\"verifyLoad !== 1 && anyUnreadNotification()\" select='.notify-finish'>\r\n    </ng-content>\r\n</div>\r\n\r\n<mat-menu #menu=\"matMenu\" yPosition=\"below\" xPosition=\"before\" [class]=\"'notification-container'\">\r\n  <div class=\"arrow\" [ngClass]=\"!loading ? 'color-arrow' : ''\"></div>\r\n  <div *ngIf=\"loading\" class=\"container-loading\">\r\n      <mat-spinner class=\"small-spinner\"></mat-spinner>\r\n  </div>\r\n  <div *ngIf=\"!loading\" (click)=\"$event.stopPropagation();\" [class]=\"'notification-container-body'\">\r\n    <div class=\"notification-title mat-title\"> Notifica\u00E7\u00F5es </div>\r\n    <mat-divider class=\"header-divider\"></mat-divider>\r\n    <div class=\"container-notification-empty\" *ngIf=\"!anyNotification()\">\r\n      <span class=\"container-icon\">\r\n        <mat-icon [inline]=\"true\">notifications</mat-icon>\r\n      </span>\r\n      <br/>\r\n      <span class=\"title\">Suas notifica\u00E7\u00F5es s\u00E3o exibidas aqui</span>\r\n      <br/>\r\n      <div class=\"sub-title\">No momento voc\u00EA n\u00E3o tem nenhuma notifica\u00E7\u00E3o, caso chegue alguma, ela ir\u00E1 aparecer aqui.</div>\r\n    </div>\r\n\r\n    <div *ngIf=\" anyNotification()\">\r\n      <div class=\"content-scroll\">\r\n        <div *ngFor=\"let item of notifications\">\r\n          <rte-nc-notification-display\r\n            [notification]=\"item\"\r\n            [popover]=\"true\"\r\n            [menuTrigger]=\"menuTrigger\"\r\n            (onclicknotification)=\"onClickNotificationItem($event);\">\r\n          </rte-nc-notification-display>\r\n          <mat-divider></mat-divider>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"container-footer\">\r\n      <button class=\"see-more\" \r\n        (click)=\"openAllNotification()\" \r\n        *ngIf=\"anyNotification()\" \r\n        href=\"javascript:void(0);\"\r\n        style=\"outline: none;\">Ver mais</button>\r\n    </div>\r\n  </div>\r\n</mat-menu>\r\n",
                    encapsulation: ViewEncapsulation.None,
                    styles: [".no-load-spinner{display:none}.badge-lens span.mat-badge-content{margin-top:.8em;margin-right:.63em;background-color:transparent!important;color:#000;font-size:12px!important}.mat-menu-content:not(:empty){padding-top:0;padding-bottom:0}.mat-menu-content{border-style:solid;border-color:rgba(0,0,0,.12);border-width:thin}.notification-title{padding:18px 5px 18px 20px;position:relative;background-color:#f5f5f5;text-align:justify;margin:0!important}.notification-container{margin-top:16px!important;max-width:600px!important;width:100vw!important;border-radius:3px!important;overflow:visible!important;position:fixed;right:35px}.notification-container.mat-menu-before{margin-right:-35px}.notification-container.mat-menu-after{margin-left:-35px}.notification-container .content-scroll{max-height:calc(100vh - 175px);overflow-y:auto}mat-spinner.small-spinner.small-spinner{width:60px!important;height:60px!important;margin:auto}mat-spinner.small-spinner svg{width:60px!important;height:60px!important}.container-loading{position:relative;padding-top:100px;padding-bottom:100px;background-color:#fff}.notification-target{cursor:pointer;display:inline-block}.notification-container .container-footer{font-family:Roboto;font-style:normal;font-weight:400;font-size:12px;line-height:18px;padding:10px 7px 7px 20px;color:#0d47a1;text-align:center}.header-divider{border:1px solid #bdbdbd}.notification-container .color-arrow{background-color:#f5f5f5!important}.notification-container .arrow{height:40px;width:40px;margin-bottom:-40px;background-color:#fff;transform:rotate(45deg);margin-top:-6px;border-style:solid;border-color:rgba(0,0,0,.12);border-width:thin}.notification-container.mat-menu-before .arrow{float:right;margin-right:25px}.notification-container.mat-menu-after .arrow{float:left;margin-left:25px}.container-notification-empty{padding:80px 0;position:relative;background-color:#fff;text-align:justify;-moz-text-align-last:center;text-align-last:center}.container-notification-empty mat-icon{opacity:.05}.container-notification-empty .title{color:#7a7a7a}.container-notification-empty .container-icon{font-size:180px;line-height:1}.notification-container .sub-title{font-family:Roboto;font-style:normal;font-weight:400;font-size:16px;line-height:22px;color:#898989;max-width:300px;margin:10px auto auto}.see-more{width:100%;height:100%;background-color:transparent;border:none;cursor:pointer;color:#00f}.container-footer:hover{background-color:#eee}.mat-badge-content{right:16px!important;top:8px!important;width:17px!important;height:17px!important;line-height:15px!important;font-size:9px!important}"]
                }] }
    ];
    /** @nocollapse */
    RteNotificationComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] },
        { type: RteNotificationCenterService },
        { type: RteDialog },
        { type: Router },
        { type: TabService }
    ]; };
    RteNotificationComponent.propDecorators = {
        notificationSize: [{ type: Input }],
        menuTrigger: [{ type: ViewChild, args: [MatMenuTrigger,] }]
    };
    return RteNotificationComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotificationDisplayComponent = /** @class */ (function () {
    function NotificationDisplayComponent(service, sanitizer, rteColorService) {
        this.service = service;
        this.sanitizer = sanitizer;
        this.rteColorService = rteColorService;
        this.onclicknotification = new EventEmitter();
        this.onclicknotificationPanel = new EventEmitter();
        this.panelOpenState = false;
        this.notificationMessage = NotificationStatusMessageEnum.Message;
        this.notificationSpinner = NotificationStatusMessageEnum.Spinner;
        this.notificationSuccess = NotificationStatusMessageEnum.Success;
        this.notificationError = NotificationStatusMessageEnum.Error;
    }
    /**
     * @return {?}
     */
    NotificationDisplayComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} notification
     * @return {?}
     */
    NotificationDisplayComponent.prototype.isUnreadNotification = /**
     * @param {?} notification
     * @return {?}
     */
    function (notification) {
        if (notification.Status === 'NL') {
            return 'unread';
        }
        return 'read';
    };
    /**
     * @param {?} notification
     * @return {?}
     */
    NotificationDisplayComponent.prototype.getPanelHeaderScss = /**
     * @param {?} notification
     * @return {?}
     */
    function (notification) {
        if (this.panelOpenState) {
            if (notification.StatusMessage === this.notificationMessage) {
                return 'notify';
            }
            else if (notification.StatusMessage === this.notificationSpinner) {
                return 'notify-spinner';
            }
            else if (notification.StatusMessage === this.notificationSuccess) {
                return 'success';
            }
            else if (notification.StatusMessage === this.notificationError) {
                return 'error';
            }
        }
        return '';
    };
    /**
     * @param {?} notification
     * @return {?}
     */
    NotificationDisplayComponent.prototype.getPanelHeaderColor = /**
     * @param {?} notification
     * @return {?}
     */
    function (notification) {
        if (this.panelOpenState) {
            if (notification.StatusMessage === this.notificationMessage) {
                return this.rteColorService.getMenuColor();
            }
        }
        return '';
    };
    /**
     * @param {?} item
     * @return {?}
     */
    NotificationDisplayComponent.prototype.openedPanel = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.panelOpenState = true;
        if (item) {
            this.onclicknotificationPanel.emit(item);
        }
    };
    /**
     * @param {?} event
     * @param {?} item
     * @return {?}
     */
    NotificationDisplayComponent.prototype.onClickNotificationItem = /**
     * @param {?} event
     * @param {?} item
     * @return {?}
     */
    function (event, item) {
        /** @type {?} */
        var target = ((/** @type {?} */ (event.target)));
        if (!target.hasAttribute('href')) {
            this.onclicknotification.emit(item);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    NotificationDisplayComponent.prototype.OpenApplication = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.preventDefault();
        if (this.menuTrigger) {
            this.menuTrigger.closeMenu();
        }
        this.service.OpenApplicationNewTab(event);
    };
    NotificationDisplayComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-nc-notification-display',
                    template: "<ng-container *ngIf=\"popover; else elseBlock\">\r\n  <div class=\"notification-item\" [ngClass]=\"isUnreadNotification(notification)\" (click)=\"onClickNotificationItem($event, notification)\">\r\n    <div class=\"picture\">\r\n      <mat-icon *ngIf=\"notification.StatusMessage === notificationMessage\" class=\"icon\">chat</mat-icon>\r\n      <mat-icon *ngIf=\"notification.StatusMessage === notificationSpinner\" class=\"icon\"><mat-spinner mode=\"indeterminate\" strokeWidth=\"3\" [diameter]=\"22\"></mat-spinner></mat-icon>\r\n      <mat-icon *ngIf=\"notification.StatusMessage === notificationSuccess\" class=\"icon icon-success\">check_circle</mat-icon>\r\n      <mat-icon *ngIf=\"notification.StatusMessage === notificationError\" class=\"icon icon-error\">error</mat-icon>\r\n    </div>\r\n\r\n    <div class=\"content\">\r\n      <span [rteTooltip]=\"notification.Title\" class=\"body-truncate\">{{notification.Title}}</span>\r\n    </div>\r\n    <div class=\"notification-date\">\r\n      <rte-retroactive-label [date]=\"notification.CreationDate\"> </rte-retroactive-label>\r\n    </div>\r\n\r\n    <mat-divider></mat-divider>\r\n  </div>\r\n</ng-container>\r\n<ng-template #elseBlock>\r\n  <div>\r\n    <rte-expansion-panel (opened)=\"openedPanel(notification)\" (closed)=\"panelOpenState = false\">\r\n      <rte-expansion-panel-header class=\"panel-header\" [ngClass]=\"getPanelHeaderScss(notification)\" [ngStyle]=\"{'background-color': getPanelHeaderColor(notification)}\">\r\n        <rte-panel-title class=\"panel-title body-truncate\" [ngClass]=\"[isUnreadNotification(notification), getPanelHeaderScss(notification)]\" [ngStyle]=\"{'background-color': getPanelHeaderColor(notification)}\">\r\n          <div class=\"picture\">\r\n            <mat-icon *ngIf=\"notification.StatusMessage === notificationMessage\" class=\"icon icon-notify\">chat</mat-icon>\r\n            <mat-icon *ngIf=\"notification.StatusMessage === notificationSpinner\" class=\"icon\"><mat-spinner mode=\"indeterminate\" strokeWidth=\"3\" [diameter]=\"22\"></mat-spinner></mat-icon>\r\n            <mat-icon *ngIf=\"notification.StatusMessage === notificationSuccess\" class=\"icon icon-success\">check_circle</mat-icon>\r\n            <mat-icon *ngIf=\"notification.StatusMessage === notificationError\" class=\"icon icon-error\">error</mat-icon>\r\n          </div>\r\n          {{notification.Title}}\r\n        </rte-panel-title>\r\n      </rte-expansion-panel-header>\r\n  \r\n      <div class=\"content expansion\">\r\n        <div #divBody (click)=\"OpenApplication($event)\" class=\"body-truncate\" [innerHTML]=\"sanitizer.bypassSecurityTrustHtml(notification.Message)\"></div>\r\n        <rte-progress-bar mode=\"indeterminate\" *ngIf=\"notification.StatusMessage === notificationSpinner\"></rte-progress-bar>\r\n      </div>\r\n      <div class=\"footer\">\r\n        <span *ngIf=\"notification.StatusMessage !== notificationSpinner\">\r\n          {{notification.CreatorUserName}}, em {{notification.CreationDate.toLocaleString().slice(0,16)}} - <rte-retroactive-label [date]=\"notification.CreationDate\"></rte-retroactive-label>\r\n        </span> \r\n      </div>\r\n\r\n    </rte-expansion-panel>\r\n  </div>\r\n</ng-template>\r\n",
                    styles: [".notification-item{max-height:30px;display:inline-flex;flex-direction:row;font-family:Roboto;font-style:normal;font-weight:400;font-size:small;position:relative;background-color:#fff;padding:5px 20px 3px 10px;width:95%}.unread{font-weight:700}.notification-item:hover{cursor:pointer;background-color:#eee}.picture{width:50px;max-width:50px;max-height:100%;align-self:center}.expansion{padding:20px 30px 10px 60px}.footer{text-align:end;color:#9e9e9e;padding-right:30px}.content{width:75%;max-height:100%;align-self:center;margin-top:3px}.notification-item .content span{width:100%;font-size:12px!important;display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.body-truncate{color:#616161}.mat-spinner circle,.picture ::ng-deep .mat-progress-spinner circle{stroke:#00bcd4!important}.notification-date{width:20%;text-align:right;margin-top:5px}.icon{font-size:21px;margin-top:3px}.icon-notify{color:#000!important}.icon-error{color:#ef5350}.icon-success{color:#66bb6a}.notification-date{color:#9e9e9e;font-size:12px}.panel-title{align-items:center}::ng-deep .error>.mat-expansion-indicator:after,::ng-deep .notify-spinner>.mat-expansion-indicator:after,::ng-deep .notify>.mat-expansion-indicator:after,::ng-deep .success>.mat-expansion-indicator:after{color:#fff}::ng-deep .mat-expansion-panel-header{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.notify,.notify div .icon-notify{color:#fff!important}.notify-spinner{background-color:#01579b!important;color:#fff!important}.success{background-color:#66bb6a!important;color:#fff!important}.success div .icon-success{color:#fff!important}.error{background-color:#ef5350!important;color:#fff!important}.error div .icon-error{color:#fff!important}::ng-deep .mat-progress-bar-fill::after{background-color:#00bcd4}"]
                }] }
    ];
    /** @nocollapse */
    NotificationDisplayComponent.ctorParameters = function () { return [
        { type: RteNotificationCenterService },
        { type: DomSanitizer },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COLOR_SERVICE_DATA,] }] }
    ]; };
    NotificationDisplayComponent.propDecorators = {
        notification: [{ type: Input }],
        popover: [{ type: Input }],
        onclicknotification: [{ type: Output }],
        onclicknotificationPanel: [{ type: Output }],
        menuTrigger: [{ type: Input }]
    };
    return NotificationDisplayComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteNotificationCenterModule = /** @class */ (function () {
    function RteNotificationCenterModule() {
    }
    RteNotificationCenterModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatBadgeModule,
                        MatMenuModule,
                        MatProgressSpinnerModule,
                        MatDividerModule,
                        MatIconModule,
                        MatDialogModule,
                        RteRetroactiveLabelModule,
                        RouterModule,
                        RteToolbarLiteModule,
                        RteMaterialModule,
                        MatCardModule,
                        MatButtonModule,
                        RteAppTitleModule,
                        FormsModule,
                        MatAutocompleteModule,
                        MatProgressBarModule,
                        MatInputModule
                    ],
                    declarations: [RteNotificationComponent, RteNotificationComponent, RteNotificationDetailComponent, NotificationListComponent, NotificationDisplayComponent],
                    exports: [RteNotificationComponent],
                    entryComponents: [RteNotificationDetailComponent, NotificationListComponent]
                },] }
    ];
    return RteNotificationCenterModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { RteNotificationCenterService, RteNotificationComponent, RteNotificationCenterModule, NotificationDisplayComponent as ɵc, NotificationListComponent as ɵb, RteNotificationDetailComponent as ɵa };

//# sourceMappingURL=rte-notification-center.js.map